import React, { useContext } from "react";
import { Box, Typography, ImageList, ImageListItem } from "@mui/material";
import { LangContext } from "../../LanguageProvider";

const images = [
  "/photo/anticor/anti1.jpg",
  "/photo/anticor/anti2.jpg",
  "/photo/anticor/anti3.jpg",
  "/photo/anticor/anti4.jpg",
  "/photo/anticor/anti5.jpg",
  "/photo/anticor/anti6.jpg",
  "/photo/anticor/anti7.jpg",
  "/photo/anticor/anti8.jpg",
];

export default function AntiCoruption() {
  const { translations } = useContext(LangContext);

  return (
    <Box
      sx={{
        fontSize: "16px",
        padding: 0,
        maxWidth: "100%",
        marginTop: "100px",
        marginBottom: "100px",
      }}>
      {/* Page Header */}
      <Box sx={{ marginBottom: 2, display: "flex", justifyContent: "center" }}>
        <Typography variant="h4" component="h1" sx={{ fontSize: "26px" }}>
          {translations["anti_coruption"] || "Антикоррупция"}{" "}
        </Typography>
      </Box>

      {/* Image Gallery */}
      <ImageList cols={1} gap={10} sx={{ maxWidth: "600px", margin: "0 auto" }}>
        {images.map((src, index) => (
          <ImageListItem
            key={index}
            sx={{ border: "2px solid black", borderRadius: "8px" }}>
            <img
              src={src}
              alt={`Anti Corruption ${index + 1}`}
              loading="lazy"
              style={{
                backgroundColor: "#f1f1f1",
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "20px",
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}